import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function SiteFrame({ children }) {
  return (
    <div className="min-h-screen bg-background text-darkgray font-sans">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
